var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',_vm._g(_vm._b({attrs:{"default-option-label":"Automático","options":_vm.locales,"opt-label":"name"}},'FormSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }